import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function useBasePath() {
  const { user } = useAuth();
  const { pathname } = useLocation();

  const portalMatch = pathname.match(/\/super-admin\/funds\/([^/]+)\/portal/);
  if (portalMatch) {
    return `/super-admin/funds/${portalMatch[1]}/portal`;
  }

  if (user?.role === "super_admin") return "/super-admin";
  if (user?.role === "admin") return "/admin";
  return "/investor";
}
